export default __webpack_public_path__ + "static/media/11_banner-big-data.dca93f52.jpg";